var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_question",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.072 4c-19.8 0-36 16.1-36 36s16.2 36 36 36c19.9 0 36-16.1 36-36s-16.2-36-36-36zm0 68c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.4 32 32-14.3 32-32 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.372 25.4c-.8-.8-1.9-1.5-3.1-1.9-1.2-.4-2.6-.7-4.1-.7-2 0-3.7.2-5.1.7-1.4.4-2.7 1-3.9 1.8l2.1 3.4c1-.6 2-1.1 3.1-1.4 1-.3 2.3-.5 3.9-.5 1 0 1.9.1 2.7.4.7.3 1.3.6 1.7 1.1.4.4.8.9 1 1.5.2.6.4 1.3.4 2.1 0 1-.1 1.9-.4 2.7-.3.8-.7 1.6-1.2 2.2-.5.7-1.1 1.4-1.7 2-.7.7-1.4 1.5-2.1 2.4-.9.8-1.5 1.8-1.9 2.8-.5 1.2-.7 2.5-.7 4h4c0-.9.1-1.7.4-2.4.3-.7.7-1.4 1.2-2.1.5-.7 1.1-1.4 1.8-2l2.1-2.4c.7-.9 1.3-2 1.7-3.1.5-1.2.7-2.6.7-4.2 0-1.2-.2-2.4-.6-3.5-.5-1.1-1.1-2.1-2-2.9zm-5.3 26.5h-4v4.9h4v-4.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrQuestion);
export default __webpack_public_path__ + "static/media/ubr_question.fd8e1afc8e4f8c0bc60edcdeb233bcb9.svg";
export { ForwardRef as ReactComponent };